module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "f_links"
  }, [_vm._l((_vm.props.acf.client_lists), function(clientList) {
    return (_vm.props) ? _c('a', {
      attrs: {
        "href": clientList.client_url,
        "target": "_blank",
        "aria-label": "logo"
      }
    }, [_c('img', {
      attrs: {
        "src": clientList.client_logo,
        "alt": "logo"
      }
    })]) : _vm._e()
  }), _c('div', {
    staticClass: "f_address"
  }, [_c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.suite_c)
    }
  })])], 2)]), _c('div', {
    staticClass: "seo"
  }, [_c('router-link', {
    staticClass: "directory",
    attrs: {
      "to": "/site-directory",
      "target": "_blank",
      "aria-label": "site directory"
    }
  }, [_vm._v("Site Map | "), _c('span', {
    domProps: {
      "innerHTML": _vm._s(_vm.props.acf.copy_right)
    }
  })]), _c('router-link', {
    attrs: {
      "to": "/",
      "target": "_blank",
      "aria-label": "Home"
    }
  }, [_vm._v("All Rights Reserved")]), _vm._v(" | "), _c('router-link', {
    attrs: {
      "to": "/privacy-policy",
      "target": "_blank",
      "aria-label": "Privacy Policy"
    }
  }, [_vm._v("Privacy Policy")])], 1), _c('div', {
    directives: [{
      name: "scroll-to",
      rawName: "v-scroll-to",
      value: ('#page'),
      expression: "'#page'"
    }],
    staticClass: "back-bar",
    attrs: {
      "id": "backTop",
      "href": "#"
    }
  }, [_c('a', {
    attrs: {
      "herf": "",
      "aria-label": "hello"
    }
  }, [_vm._v("hello")])]), _c('div', {
    attrs: {
      "id": "accessibilityWidget",
      "tabindex": "0"
    }
  }, [_vm._v("Click for Accessibility")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2c8a3b3c","hasScoped":false}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./src/components/footer/footer.pug
// module id = 580
// module chunks = 1